var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-list-item-image"},[_c('img',_vm._b({},'img',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }